import axios from "axios";
import React, { useEffect } from "react";
import GetServerAddress from "../../functions/GetServerAddress";

export function Get_One_From_MongoDB(
  dbName,
  collctiontext,
  id,
  setdata,
  logout
) {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/staff/Get_One_From_MongoDB",
        {
          dbName: dbName,
          collctiontext: collctiontext,
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "No",
            aboutid: id,
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        return; // Stop further execution in case of invalid auth token
      }
      //Check if nothing found
      if (response.data.data.length === 0) {
        window.alert(
          "Error, No data found matching your search. Please try again or get Admin support"
        );
        console.log(
          "Error, No data found matching your search. Please try again or get Admin support"
        );
      } else {
        setdata(response.data.data[0]); // Update your state with the fetched data
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };

  fetchData();
} // Empty dependency array means this effect runs only once
